import httpClientePublicoCore from '../../Servicios/httpClientePublicoCore';

export const obtenerPoliticasContrasena = () => {
    return new Promise((resolve, reject) => {
        httpClientePublicoCore.post("/PoliticasContrasena/Consultar/", {}).then(response => {
            resolve(response);
        }).catch(error => {
            resolve(error.response);
        });
    });
};